module.exports = __webpack_public_path__ + "img/coverage@1x.dfd4e8f3.png";